export default "__VITE_ASSET__D21iZ4nZ__"